const GET_ASSET_ITEM_STATUS_TASK_DETAIL = 'GET_ASSET_ITEM_STATUS_TASK_DETAIL'
const SET_ASSET_ITEM_STATUS_TASK_DETAIL = 'SET_ASSET_ITEM_STATUS_TASK_DETAIL'

 const SET_IS_ASSET_ITEM_STATUS_TASK_DETAIL_CALLED = "SET_IS_ASSET_ITEM_STATUS_TASK_DETAIL_CALLED"
export {
    GET_ASSET_ITEM_STATUS_TASK_DETAIL,
    SET_ASSET_ITEM_STATUS_TASK_DETAIL,
    SET_IS_ASSET_ITEM_STATUS_TASK_DETAIL_CALLED
}
